export { default } from './GiftOffer';
